<template>
    <div id="import-history-page">
        <div class="container-fluid">
            <h1>{{ t('importHistory-title') }}</h1>
            <confirm id="confirmCancel" ref="confirmCancel" @confirm="cancelImportHistory" buttonClass="btn-danger">
                <template slot="title">
                    <span>{{ t('importHistory-confirmTitle') }}</span>
                </template>
                <template slot="body">
                    <div>
                        {{ t('importHistory-confirmPrefix') }}
                        <strong>{{ t('importHistory-confirmHighlight') }}</strong>.

                        <br />
                        <br />
                        {{ t('importHistory-confirmIrreversible') }}
                    </div>
                </template>
            </confirm>
            <form-history @historyCreated="onHistoryCreated" class="mt-4" />
            <div>
                <template v-if="ready">
                    <grid :source="`plugins/${$route.params.pluginPlaceId}/import-history/list`" :filters="{}" :showSearch="false">
                        <template v-slot:rows="grid">
                            <thead>
                                <tr>
                                    <grid-th :grid="grid">{{ t('importHistory-columnId') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnStartDate') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnEndDate') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnLastImportedDate') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnStatus') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnImportedDays') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnRemainingDays') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnProgress') }}</grid-th>
                                    <grid-th :grid="grid">{{ t('importHistory-columnActions') }}</grid-th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="importHistory in grid.data" :key="importHistory.id">
                                    <td>
                                        {{ importHistory.id }}
                                    </td>
                                    <td style="min-width: 150px">
                                        <human-date :date="importHistory.date_start" format="[d]/[M]/[Y]" />
                                    </td>
                                    <td>
                                        <human-date :date="importHistory.date_end" format="[d]/[M]/[Y]" />
                                    </td>
                                    <td>
                                        <human-date v-if="importHistory.last_imported_date"
                                            :date="importHistory.last_imported_date" format="[d]/[M]/[Y]" />
                                        <span v-else>{{ t('importHistory-noImportPerformed') }}</span>
                                    </td>
                                    <td>
                                        <status-flag :status="importHistory.status" />
                                    </td>
                                    <td>
                                        {{ importHistory.imported_days }}
                                    </td>
                                    <td>
                                        {{ importHistory.remaining_days }}
                                    </td>
                                    <td>
                                        <progressBar :progress=" importHistory.percentage_completed" /></td>
                                    <td>
                                        <button :disabled="['complete', 'cancelled'].includes(importHistory.status)" class="btn btn-sm btn-danger" v-if="user.global_admin"
                                            @click.prevent="makeCancelRequest(importHistory.id)" >
                                            {{ t('importHistory-cancelButton') }}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </grid>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi.js";
import statusFlag from "./status-flag.vue";
import progressBar from "./progress-bar.vue";
import formHistory from "./form.vue";

export default {
    data() {
        return {
            ready: false,
            importHistoryIdToCancel: null,
        };
    },
    components: {
        statusFlag,
        progressBar,
        formHistory
    },
    computed: {
        user() {
            return this.$store.state.user;
        },

    },
    async mounted() {
        this.ready = true;
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        onHistoryCreated(){
            this.ready = false;
            this.ready = true;
        },
        makeCancelRequest(importHistoryId){
            this.importHistoryIdToCancel = importHistoryId;
            this.$refs.confirmCancel.open()
        },
        cancelImportHistory() {
            const options = keviApi.getOptions("/plugins/import-history/"+ this.importHistoryIdToCancel +"/cancel", "PUT");
            this.ready = false;
            this.$http(options).then((response) => {
                if (response.status === 201) {
                    this.ready = true;
                    this.$store.dispatch(
                        "notification/success",
                        this.t("importHistory-cancelSuccessNotification"),
                    );
                }
                else{
                    this.$store.dispatch(
                        "notification/warning",
                        this.t("importHistory-cancelErrorNotification"),
                    );
                }
            });
        },
    },
};
</script>

<style>
.page-content{
    max-width: 100% !important;
}
</style>
